var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutDefault", { staticClass: "launch" }, [
    _c(
      "div",
      { staticClass: "loader-wrapper auth" },
      [
        _c("img", {
          staticClass: "loader",
          attrs: { src: require("@/assets/svg/loading.svg") },
        }),
        _c("Logo"),
        _vm.errorMessage || _vm.launchError
          ? _c("div", { staticClass: "error-message" }, [
              _vm._v(" " + _vm._s(_vm.errorMessage || _vm.launchError) + " "),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }